import {
  LARGE_BREAKPOINT,
  MEDIUM_BREAKPOINT,
  SMALL_BREAKPOINT,
} from '@/components/modular-grid/constants';
import { TileSize } from '@/components/modular-grid/ModularGridGameTile/ModularGridGameTile';
import { GameTableType } from '@/types/gameTypes';

export const PORTAL_VERTICAL_GAME_TYPES: { [key: string]: GameTableType } = {
  Baccarat: 'Baccarat',
  Blackjack: 'Blackjack',
  DragonTiger: 'DragonTiger',
  ScalableBlackjack: 'ScalableBlackjack',
  Roulette: 'Roulette',
  Poker: 'Poker',
  MoneyWheel: 'MoneyWheel',
  TopCard: 'TopCard',
  Trivia: 'Trivia',
  Monopoly: 'Monopoly',
  SicBo: 'SicBo',
  DealNoDeal: 'DealNoDeal',
  SidebetCity: 'SidebetCity',
  LightningDice: 'LightningDice',
};

export const BAD_GAME = ['game-invalid', 'launch-urk-invalid'];

/**
 * Image sizes map, based on this map we can later prepare responsive images
 * using `<picture>`. Should have min, max, or both.
 */
type ImageSizes = Record<TileSize, Array<
  | { min: number; max: number; size: number; }
  | { min: number; size: number; }
  | { max: number; size: number; }
>>
export const IMAGE_SIZES: ImageSizes = {
  // The size should be 117px on mobile and 177px on tablet, according to the
  // design. But it works only in the game grid on the page and not for the
  // category details drawer because game tiles on the page have fixed width,
  // however, in the drawer it stretched with the page. So taking a max possible
  // width here. It leads to a little performance hit, since we need to load a
  // bigger image where it's not really necessary. We can address it later.
  small: [
    { // mobile
      max: SMALL_BREAKPOINT.max,
      size: 235,
    },
    { // tablet
      min: MEDIUM_BREAKPOINT.min,
      max: MEDIUM_BREAKPOINT.max,
      size: 235,
    },
    { // desktop
      min: LARGE_BREAKPOINT.min,
      size: 222,
    },
  ],
  // TODO I don't see any place where we use it. Do deeper review and clean up.
  //  For other tile sizes we use real values based on our figma design, but
  //  for the `large` option there are still old values which can be not
  //  relevant for New Vegas
  large: [
    {
      max: 500,
      size: 140,
    },
    {
      max: SMALL_BREAKPOINT.max,
      size: 270,
    },
    {
      min: MEDIUM_BREAKPOINT.min,
      max: MEDIUM_BREAKPOINT.max,
      size: 280,
    },
    {
      min: LARGE_BREAKPOINT.min,
      size: 330,
    },
  ],
  // The same as `tall-vertical`. Height is different, but we don't care because
  // we define only the width here.
  vertical: [
    { // mobile
      max: SMALL_BREAKPOINT.max,
      size: 116,
    },
    { // tablet
      min: MEDIUM_BREAKPOINT.min,
      max: MEDIUM_BREAKPOINT.max,
      size: 117,
    },
    { // desktop
      min: LARGE_BREAKPOINT.min,
      size: 222,
    },
  ],
  // The same as `vertical`. Height is different, but we don't care because
  // we define only the width here.
  'tall-vertical': [
    { // mobile
      max: SMALL_BREAKPOINT.max,
      size: 116,
    },
    { // tablet
      min: MEDIUM_BREAKPOINT.min,
      max: MEDIUM_BREAKPOINT.max,
      size: 177,
    },
    { // desktop
      min: LARGE_BREAKPOINT.min,
      size: 222,
    },
  ],
  'wide-horizontal': [
    { // mobile
      max: SMALL_BREAKPOINT.max,
      size: 240,
    },
    { // tablet
      min: MEDIUM_BREAKPOINT.min,
      max: MEDIUM_BREAKPOINT.max,
      size: 366,
    },
    { // desktop
      min: LARGE_BREAKPOINT.min,
      size: 456,
    },
  ],
};

export const GAME_LAUNCH_PLACEMENT = 'search';

export const CONTEXT_ATTRIBUTES = ['game_launch_placement', 'locale'];

export const WEB_ATTRIBUTES = ['game_launch_placement', 'segments'];

export const DYNAMIC_PATH_REGEX = /\/:id$/gm;
